export const extractErrorMessage = (payload, fallback = 'Something went wrong.') => {
    if (!payload) return fallback
    if (typeof payload === 'string') return payload
    const fromMsgAndData = payload.msg && payload.data && payload.msg !== payload.data
        ? `${payload.msg}: ${payload.data}`
        : null
    return (
        fromMsgAndData
        || payload.data
        || payload.message
        || payload.msg
        || payload.error
        || fallback
    )
}

export const extractAxiosError = async (error, fallback = 'Something went wrong.') => {
    const respData = error?.response?.data
    if (respData && typeof respData === 'object' && typeof respData.text === 'function') {
        try {
            const text = await respData.text()
            const json = JSON.parse(text)
            return extractErrorMessage(json, fallback)
        } catch (e) {
            // fall through
        }
    }
    return extractErrorMessage(respData, error?.message || fallback)
}
